<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}" class="status-button" @click="status = ACTIVE_STATUS">{{ $t('active') }}</button> <span  v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}">({{activeCount}})</span> | <button v-bind:class="{'font-weight-bold': status == DRAFT_STATUS}" class="status-button" @click="status = DRAFT_STATUS">{{ $t('draft') }}</button> <span  v-bind:class="{'font-weight-bold': status == DRAFT_STATUS}">({{draftCount}})</span> | <button v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}" class="status-button" @click="status = ARCHIVE_STATUS">{{ $t('archive') }}</button> <span  v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}">({{archiveCount}})</span>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0 gap-1">
        <SingleOptionDropdown class="flex-grow-1" v-model="selectedBrand" :options="brandOptions" :title="$t('brand')" :index="0"></SingleOptionDropdown>
        <button type="button" class="btn btn-primary" @click="addProducts">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover :caption="$t('pages')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
      <template #showOnActiveBrandsPro="{item}">
        <td class="text-center align-middle" @click.stop>
          <template v-if="item.brand === 'ActiveBrands'">
            <button
              type="button"
              class="pro-badge"
              :class="item.showOnActiveBrandsPro ? 'pro-badge--on' : 'pro-badge--off'"
              :title="item.showOnActiveBrandsPro ? $t('clickToHideFromPro') : $t('clickToShowOnPro')"
              :disabled="togglingProductId === item.id"
              @click="toggleShowOnPro(item)">
              <span v-if="item.showOnActiveBrandsPro">✓</span>
            </button>
          </template>
          <span v-else class="pro-na" :title="$t('proNotApplicable')">—</span>
        </td>
      </template>
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

const ACTIVE_STATUS = 'Active';
const DRAFT_STATUS = 'Draft';
const ARCHIVE_STATUS = 'Archive';

export default {
  components: { CTableWrapper, SearchBar, SingleOptionDropdown },
  data () {
    return {
      status: '',
      searchText: '',
      caption: i18n.t('products'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'sku', label: i18n.t('sku'), sortable: true },
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'finalPrice', label: i18n.t('finalPrice'), sortable: true },
        { key: 'categories', label: i18n.t('categories'), sorter: false },
        { key: 'showOnActiveBrandsPro', label: i18n.t('proColumn'), sorter: false, _style: 'width: 80px;' },
      ],
      actions: [],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      selectedBrand: "all",
      brandOptions: [ {label: this.$t("allBrands"), key: "all"}, {label: this.$t("activeBrands"), key: "ActiveBrands"}, {label: this.$t("inflateYourImagination"), key: "InflateYourImagination"} ],
      sorterValue: { column: 'id', asc: false },
      togglingProductId: null,
      // Provide access to consts on HTML
      ACTIVE_STATUS: ACTIVE_STATUS,
      DRAFT_STATUS: DRAFT_STATUS,
      ARCHIVE_STATUS: ARCHIVE_STATUS
    }
  },
  computed: {
    ...mapState('products', ['getProductsOutput']),
    ...mapState('products', ['putProductChangeStatusOutput']),
    ...mapState('products', ['putProductShowOnActiveBrandsProOutput']),
    productsInfo: function() {
      return this.getProductsOutput && this.getProductsOutput.data ? this.getProductsOutput.data : null;
    },
    items: function()
    {
      var result = [];

      if(this.productsInfo && this.productsInfo.products)
      {
        result = this.productsInfo.products;
        result.forEach(product => 
        { 
          product['categories'] = product.categories;

          if(product.highlighted && product.showFirst)
          {
            product['_classes'] = "table-info";
          }
          else if(product.highlighted)
          {
            product['_classes'] = "table-primary";
          }
          else if(product.showFirst)
          {
            product['_classes'] = "table-secondary";
          }
        });
      }

      return result;
    },
    activeCount: function()
    {
      return this.productsInfo ? this.productsInfo.active : 0;
    },
    draftCount: function()
    {
      return this.productsInfo ? this.productsInfo.draft : 0;
    },
    archiveCount: function()
    {
      return this.productsInfo ? this.productsInfo.archive : 0
    },
    pages: function()
    {
      return this.getProductsOutput ? this.getProductsOutput.totalPages : 1;
    },
  },
  mounted: function()
  {
    this.status = ACTIVE_STATUS;
  },
  methods: {
    ...mapActions('products', ['getProducts']),
    ...mapActions('products', ['putProductChangeStatus']),
    ...mapActions('products', ['putProductShowOnActiveBrandsPro']),
    toggleShowOnPro(item) {
      const turningOn = !item.showOnActiveBrandsPro;
      const message = turningOn
        ? this.$i18n.tc('confirmShowOnPro', item.name, { name: item.name })
        : this.$i18n.tc('confirmHideFromPro', item.name, { name: item.name });

      if (!confirm(message)) return;

      this.togglingProductId = item.id;
      this.putProductShowOnActiveBrandsPro({ productId: item.id, showOnActiveBrandsPro: turningOn });
    },
    rowClicked (item, index) {
      this.$router.push({name: "ProductEdit", query: { id: item.id }, params: {name: item.name} });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "ProductEdit", query: { id: item.id }, params: {name: item.name} });
          break;
        }
        case 'disable':
        {
          if(confirm(this.$i18n.tc('confirmDisable', item.name, { name: item.name }))){
            this.putProductChangeStatus({ productId: item.id, status: 3 });
          }
          break;
        }
        case 'enable':
        {
          if(confirm(this.$i18n.tc('confirmEnable', item.title, { name: item.name }))){
            this.putProductChangeStatus({ productId: item.id, status: 1});
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      
      // List specific parameters
      input.status = this.status;
      input.brand = this.selectedBrand === "all" ? null : this.selectedBrand;

      this.getProducts(input); 
    },
    addProducts () 
    {
      router.push({name: "ProductAdd", params: { type: this.$route.params.type } });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    status: function (val) {
      // Update actions
      switch(val) {

        case ACTIVE_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'disable', label: this.$i18n.t("archive") });
          
          break;
        }
        case DRAFT_STATUS:
        case ARCHIVE_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'enable', label: this.$i18n.t("activate") });

          break;
        }
        default:
        {
          throw "The provided status is not supported!"; 
        }
      }

      // Update items
      this.$refs.table.reset();
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    putProductChangeStatusOutput: function(val)
    {
      this.loading = val === null;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
      else if(val === false)
      {
        alert(this.$t("errorActiveProduct"));
      }
    },
    putProductShowOnActiveBrandsProOutput: function(val)
    {
      if (val === null) return;

      this.togglingProductId = null;

      if (val) {
        this.updateItemsRequested(this.$refs.table.currentPage, this.itemsPerPage);
        alert(this.$t("proVisibilityUpdated"));
      } else if (val === false) {
        alert(this.$t("errorUpdatingProVisibility"));
      }
    },
    getProductsOutput: function(val)
    {
      this.loading = false;
    },
    selectedBrand: function()
    {
      this.updateItemsRequested(1, this.itemsPerPage);
    }
  }
}
</script>

<style scoped>
.pro-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 0.85rem;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}
.pro-badge:hover:not(:disabled) {
  transform: scale(1.15);
  box-shadow: 0 0 0 3px rgba(46, 184, 92, 0.15);
}
.pro-badge:disabled {
  cursor: wait;
  opacity: 0.5;
}
.pro-badge--on {
  background-color: #2eb85c;
  color: white;
  border: none;
}
.pro-badge--off {
  background-color: transparent;
  border: 1.5px solid #c4c9d0;
}
.pro-badge--off:hover:not(:disabled) {
  border-color: #2eb85c;
}
.pro-na {
  color: #b0b6bd;
  font-weight: 500;
  user-select: none;
}
</style>